import type { DeepPartial } from '@luna/utils-ts';

import type { KycFeatureConfig } from '../type';

export const kyc: DeepPartial<KycFeatureConfig> = {
    handoverTargetClientId: 'ebcstore',
};
